import { createStyles } from '@mantine/emotion';

export const useAssistantModalStyles = createStyles((theme) => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: `${theme.spacing.sm} ${theme.spacing.md}`,
    borderBottom: theme.other.elements.appBorder,
    flex: '0 0 auto',
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing.xs,
    fontWeight: 600,
    fontSize: theme.fontSizes.lg,
    color: theme.colors.teal[6],
  },
  memberTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing.xs,
    fontWeight: 600,
    fontSize: theme.fontSizes.lg,
    color: theme.colors.blue[6],
  },
  body: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    height: '100%',
  },
  leftPanel: {
    width: 300,
    minWidth: 300,
    borderRight: theme.other.elements.appBorder,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  rightPanel: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
}));
